var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PersonalCenter flex"},[_c('PersonMenu'),_c('div',{staticClass:"PersonalCenter-container"},[_c('Head'),_c('PortraitOne',{attrs:{"hideHeader":true,"type":"course","pageTotal":_vm.pageTotal,"listData":_vm.listData},on:{"getPageSize":_vm.getPageSize,"getPageIndex":_vm.getPageIndex}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }